{
  "previous": "上一步",
  "next": "下一步",
  "complete": "完成",
  "verifyAndCheckIn": "驗證並報到",
  "loading": {
    "retrievingLocation": "正在取得位置...",
    "retrievingWarehouse": "正在取得倉庫資料..."
  },
  "validation": {
    "fieldRequired": "此欄位為必填",
    "fieldRequiredWithLabel": "{label} 為必填",
    "phoneInvalid": "此電話號碼無效",
    "phoneInvalidWithExample": "此電話號碼無效（範例：{example}）"
  }
}
